import React, { Suspense, useState, useEffect } from "react";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Nodes from "../../Helpers/nodesList.js";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import Footer from "../../DefaultLayout/Footer";
import { Link, Redirect } from "react-router-dom";
import Loading from "../../components/Loading";
import { FormGroup, Input, Col } from "reactstrap";
import InputRange from "react-input-range";

import CheckboxTree from "react-checkbox-tree";
import { BsCheck2 } from "react-icons/bs";
// css file
import "./mapview.css";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,

  MdAdd,
  MdRemove,
} from "react-icons/md";
import Header from "../../DefaultLayout/Header";
import { connect, useSelector } from "react-redux";
import MapComponent from "../../components/GoogleMap";
import {
  getPropertyList,
  unlikeProperty,
  likeProperty,
  hiddenProperty,
} from "../../actions/propertyAction";
import { toast } from "react-toastify";
import { dropdownPropertyField } from "../../actions/propertyFieldAction";
import { runningSubscription } from "../../actions/subscription";
import swal from "sweetalert";
const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,
  // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
};




const MapView1 = (props) => {
  const lng = localStorage.getItem("prevLangFront");
  const { frontLabelsName } = props.label;
  const { dropdownPropertyField } = props;
   const nodes = Nodes(); 
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [inhabitants, setInhabitants] = useState("");
  const [gender, setGender] = useState("");
  const [smoking, setSmoking] = useState("");
  const [pets, setPets] = useState("");

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  // const classes = useStyles();

  const [val, setVal] = useState({ min: 0, max: 100 });

  const [val2, setVal2] = useState({ min: 0, max: 100 });
  const [openZip, setOpenZip] = useState(false);
  const [propPriceVal, setPropPriceVal] = useState({ min: 100, max: 2000000 });
  const [propSizeVal, setPropSizeVal] = useState({ min: 0, max: 1000000 });
  const [open, setOpen] = useState(true);
  const [open1, setOpen1] = useState(false);
  const [checkbox, setCheckbox] = useState({
    Furniture: false,
    withElevator: false,
    Garage: false,
    storage: false,
    bathroomBath: false,
    privateEntrance: false,
    withCharging: false,
    laundryFacilitiesInTheBasement: false,
    withWheelchair: false,
    withBalcony: false,
    Pets: false,
  });

  const [tableOpen, setTableOpen] = useState(false);
  const [allData, setAllData] = useState(true);
  const [menuOpen, setMenuOpen] = useState(true);

  const [checkedTree, setCheckedTree] = useState(["0"]);
  const [expandedTree, setExpandedTree] = useState();
  const [filterText, setFilterText] = useState("");
  const [nodesFiltered, setNodesFiltered] = useState();
  const [clickedTree, setClickedTree] = useState([]);

  const [newToday, setNewToday] = useState(false);
  const [newThisWeek, setNewThisWeek] = useState(false);
  const [room, setRoom] = useState("");
  const [rentalPeriod, setRentalPeriod] = useState("");
  const [propertyType, setPropertyType] = useState("");

  const [filterLoading, setFilterLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [navType, setNavType] = useState("");
  const [enterSearch, setEnterSearch] = useState("");

  const [priceData, setPriceData] = useState("");
  const [sizeData, setSizeData] = useState("");

  const [included1, setIncluded1] = useState([]);
  const [other, setOther] = useState([]);

  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherType, setOtherType] = useState([]);
  const [checkedPropertyFieldTree, setCheckedPropertyFieldTree] = useState([
    "0",
  ]);
  const [expandedPropertyFieldTree, setExpandedPropertyFieldTree] = useState([
    "0",
  ]);
  const [filterPropertyFieldText, setFilterPropertyFieldText] = useState("");

  const [clickedPropertyFieldTree, setClickedPropertyFieldTree] = useState([]);

  const subscriptions = useSelector((state) => state.subscription);
  const subscription_details = subscriptions?.runningSubscription?.message;

  const tempIncluded = Object.keys(checkbox).map((val) => {
    if (checkbox[val] === true) {
      return val;
    } else {
      return false;
    }
  });

  const included = tempIncluded.filter((val) => val);

  useEffect(() => {
    if (isAuth.isAuthenticated) {
      const userId = localStorage.getItem("user");
      props.runningSubscription(userId);
    }
  }, []);

  const ArrayChangeHandler = (arr) => {
    arr.forEach((object) => {
      object.value = object._id;
    });
    const newArrayOfHomeAppliance =
      arr?.length > 0 &&
      arr.map(({ _id: id, name, ...rest }) => {
        let label=Array.isArray(name) ? name?.filter((e)=>(  (e[lng])))[0][lng]['name']:name
     
      

    
 
        return{
          id,label,...rest
      }});

    return newArrayOfHomeAppliance;
  };

  useEffect(() => {
    dropdownPropertyField("").then((res) => {
      //setIncluded1(res?.type_1);
      setHomeApplianceType(ArrayChangeHandler(res?.type_2));
      setRestrictionsType(ArrayChangeHandler(res?.type_3));
      setAccessType(ArrayChangeHandler(res?.type4));
      setOtherType(ArrayChangeHandler(res?.type5));
    });
  }, [lng]);

  useEffect(() => {
    setFilterLoading(true);

    props
      .getPropertyList(
        1,
        100000,
        search,
        room,
        filterText,
        rentalPeriod,
        propertyType,
        propSizeVal.min,
        propSizeVal.max,
        propPriceVal.min,
        propPriceVal.max,
        newToday ? "1" : newThisWeek ? "2" : "",
        // included.toString(),
        filterPropertyFieldText.toString(),
        navType,
        smoking,
        pets,
        gender,
        inhabitants
      )
      .then(() => {
        setFilterLoading(false);
      });
  }, [
    getPropertyList,
    navType,
    enterSearch,
    room,
    filterText,
    rentalPeriod,
    propertyType,
    sizeData,
    priceData,
    newToday,
    newThisWeek,
    checkbox,
    filterPropertyFieldText,
    smoking,
    pets,
    gender,
    inhabitants,
  ]);

  const propertyFieldNodes = [
    {
      id: 3001,
      value: "3001",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances")[0][
              "value"
            ] || "lbl_home_appliances"
          : "lbl_home_appliances"
        : "lbl_home_appliances",
      children: homeApplianceType,
    },
    {
      id: 3002,
      value: "3002",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_restrictions").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")[0]["value"] ||
            "lbl_restrictions"
          : "lbl_restrictions"
        : "lbl_restrictions",
      children: restrictionsType,
    },
    {
      id: 3003,
      value: "3003",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_access").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_access")[0]["value"] ||
            "lbl_access"
          : "lbl_access"
        : "lbl_access",
      children: accessType,
    },
    {
      id: 3004,
      value: "3004",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_other").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0]["value"] ||
            "lbl_other"
          : "lbl_other"
        : "lbl_other",
      children: otherType,
    },
  ];

  ///FILTER LOGIC (serach nodes in particular list)//

  const onFilterChange = (e) => {
    if (e.target.value.length >= 3) {
      setFilterText(e.target.value);
      if (e.target.value) {
        filterTree();
      }
    } else {
      setFilterText("");
    }
  };

  const filterTree = () => {
    // Reset nodes back to unfiltered state
    if (!filterText || filterText === "" || filterText.length === 0) {
      setNodesFiltered(nodes);
      return;
    }

    const nodesFiltered = (nodes) => {
      return nodes.reduce(filterNodes, []);
    };

    setNodesFiltered(nodesFiltered);
  };

  const filterNodes = (filtered, node) => {
    const children = (node.children || []).reduce(filterNodes, []);
    if (
      // Node's label matches the search string
      node.label.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
        -1 ||
      // Or a children has a matching node
      children.length
    ) {
      filtered.push({ ...node, ...(children.length && { children }) });
    }
    return filtered;
  };
  //

  const handleHideButton = () => {
    setOpen(!open);
  };

  const handleCheckbox = (e) => {
    let { name, checked } = e.target;
    var selected = e.checkbox;

    setCheckbox({ ...checkbox, [e.target.name]: e.target.value });
  };

  const handleClose = () => {
    setOpen1(!open1);
  };

  const handleTableData = () => {
    setTableOpen(true);
    setAllData(false);
  };
  const handleAllData = () => {
    setAllData(true);
    setTableOpen(false);
  };

  const handleZipCode = () => {
    filterTree();
    setOpenZip(!openZip);
    setMenuOpen(!menuOpen);
  };

  const isAuth = useSelector((state) => state.auth.isAuthenticated);

  const { property, propertyLoading } = useSelector(
    (state) => state.properties
  );

  const onApplyFilter = () => {
    // setFilterLoading(true);
    // const tempIncluded = Object.keys(checkbox).map((val) => {
    //   if (checkbox[val] === true) {
    //     return val;
    //   } else {
    //     return false;
    //   }
    // });
    // const included = tempIncluded.filter((val) => val);
    // props
    //   .getPropertyList(
    //     1,
    //     10000,
    //     search,
    //     room,
    //     filterText,
    //     rentalPeriod,
    //     propertyType,
    //     propSizeVal.min,
    //     propSizeVal.max,
    //     propPriceVal.min,
    //     propPriceVal.max,
    //     newToday ? "1" : newThisWeek ? "2" : "",
    //     included.toString(),
    //     ""
    //   )
    //   .then(() => {
    //     setFilterLoading(false);
    //   });
  };

  const onResetFilter = () => {
    setFilterLoading(true);

    props
      .getPropertyList(
        1,
        10000,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      )
      .then(() => {
        setFilterLoading(false);
      });
    setSearch("");
    setRoom("");
    setFilterText("");
    setRentalPeriod("");
    setNewThisWeek(false);
    setNewToday(false);
    setPropPriceVal({ min: 100, max: 2000000 });
    setPropSizeVal({ min: 0, max: 1000000 });
    setCheckbox({
      Furniture: false,
      withElevator: false,
      Garage: false,
      storage: false,
      bathroomBath: false,
      privateEntrance: false,
      withCharging: false,
      laundryFacilitiesInTheBasement: false,
      withWheelchair: false,
      withBalcony: false,
      Pets: false,
    });
    setPropertyType("");
    setCheckedTree(["0"]);
    setExpandedTree(["0"]);
    setOpenZip(false);
    setFilterPropertyFieldText("");
    setExpandedPropertyFieldTree(["0"]);
    setCheckedPropertyFieldTree(["0"]);
    setSmoking("");
    setInhabitants("");
    setGender("");
    setPets("");
  };

  const onNavSearch = (navSearch) => {
    setFilterLoading(true);

    props
      .getPropertyList(
        1,
        12,
        navSearch,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      )
      .then(() => {
        setFilterLoading(false);
      });
  };

  const handleEnter = (e) => {
    if (e.target.name === "search") {
      if (e.key === "Enter") {
        setEnterSearch(e.target.value);
      }
    }
  };

  const unlike = async (property_id) => {
    if (isAuth) {
      await props.unlikeProperty(property_id).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
                ress.message
              : ress.message
            : ress.message
        );
        props.getPropertyList(
          1,
          10000,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const like = async (property_id) => {
    if (isAuth) {
      let newAddLike = {
        property_id: property_id,
      };
      const res = await props.likeProperty(newAddLike).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.data.message)[0][
                  "value"
                ] || ress.data.message
              : ress.data.message
            : ress.data.message
        );
        props.getPropertyList(
          1,
          10000,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const hidden = async (property_id) => {
    if (isAuth) {
      let newhidden = {
        property_id: property_id,
      };
      const res = props.hiddenProperty(newhidden).then((ress) => {
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == ress.message).length > 0
              ? frontLabelsName.filter((e) => e.key == ress.message)[0]["value"] ||
                ress.message
              : ress.message
            : ress.message
        );
        props.getPropertyList(
          1,
          10000,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  const getIncludedName = (val) => {
    if (val === "Stove Four burner") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_stove_four_burner").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_stove_four_burner")[0][
              "value"
            ] || "lbl_stove_four_burner"
          : "lbl_stove_four_burner"
        : "lbl_stove_four_burner";
    } else if (val === "Television") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_television").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_television")[0]["value"] ||
            "lbl_television"
          : "lbl_television"
        : "lbl_television";
    } else if (val === "Dishwasher") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_dishwasher").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_dishwasher")[0]["value"] ||
            "lbl_dishwasher"
          : "lbl_dishwasher"
        : "lbl_dishwasher";
    } else if (val === "Garage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage";
    } else if (val === "With Balcony") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_television").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_television")[0]["value"] ||
            "lbl_television"
          : "lbl_television"
        : "lbl_television";
    } else if (val === "With Balcony") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_with_balcony").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_with_balcony")[0]["value"] ||
            "lbl_with_balcony"
          : "lbl_with_balcony"
        : "lbl_with_balcony";
    } else if (val === "Storage") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_storage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0]["value"] ||
            "lbl_storage"
          : "lbl_storage"
        : "lbl_storage";
    } else if (val === "Elevator") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_elevator").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_elevator")[0]["value"] ||
            "lbl_elevator"
          : "lbl_elevator"
        : "lbl_elevator";
    } else if (val === "Laundry Facilities in the basement") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_laundry_facilities").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_laundry_facilities")[0][
              "value"
            ] || "lbl_laundry_facilities"
          : "lbl_laundry_facilities"
        : "lbl_laundry_facilities";
    } else if (val === "Private entrance") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_private_entrance").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_private_entrance")[0][
              "value"
            ] || "lbl_private_entrance"
          : "lbl_private_entrance"
        : "lbl_private_entrance";
    } else if (val === "Bathroom bath") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_bathroom_bath").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_bathroom_bath")[0][
              "value"
            ] || "lbl_bathroom_bath"
          : "lbl_bathroom_bath"
        : "lbl_bathroom_bath";
    } else if (val === "Furniture") {
      return frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_furniture").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_furniture")[0]["value"] ||
            "lbl_furniture"
          : "lbl_furniture"
        : "lbl_furniture";
    }
  };

  // check user is subscribed or not
  if (subscription_details !== "Your subscription is active.") {
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_purchage_subscribe")[0][
              "value"
            ] || "lbl_purchage_subscribe"
          : "lbl_purchage_subscribe"
        : "lbl_purchage_subscribe",
      text: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_to_view").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_subscribe_to_view")[0][
              "value"
            ] || "lbl_subscribe_to_view"
          : "lbl_subscribe_to_view"
        : "lbl_subscribe_to_view",
      icon: "info",
      buttons: [
        null,
          frontLabelsName
         ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
           ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0][
               "value"
             ] || "lbl_continue"
           : "lbl_continue"
         : "lbl_continue"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
    return <Redirect to={"/subscription"} />;
  }

  return (
    <>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}
{/* 
        <NavbarSection
          setType={setNavType}
          isCardView={false}
          onNavSearch={onNavSearch}
        /> */}
         <DashboardNavbar/>
      </Suspense>

      <div className="main-box cutom-zip-code-main">
        <div className="row">
          {/* navigation */}
          {/* <div className="content-wrapper"> */}
          <div
            className="col-lg-2"
            style={{ marginBottom: "15px", marginTop: "7px" }}
          >
            <div className="filter-btn-three1">
              <Link to="/properties">
                <img src="assets/card-active.svg" alt="Group 13521" />
              </Link>
              <Link to="/properties-list">
                <img src="assets/list.svg" alt="Group 13521" />
              </Link>
              <Link to="/properties-map">
                <img
                  src="assets/location.svg"
                  alt="Group 13521"
                  className="icon-shadows1"
                />
              </Link>
            </div>

            <div className="new-add-checkboxs">
              <div className="new padding-style">
                <form>
                  <div className="form-group mb-3">
                    <input
                      type="checkbox"
                      id="New today"
                      checked={newToday}
                      onChange={(e) => setNewToday(!newToday)}
                    />
                    <label for="New today">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_new_today")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_new_today"
                            )[0]["value"] || "lbl_new_today"
                          : "lbl_new_today"
                        : "lbl_new_today"}
                    </label>
                  </div>
                  <div className="form-group ">
                    <input
                      type="checkbox"
                      id="New this week"
                      checked={newThisWeek}
                      onChange={(e) => setNewThisWeek(!newThisWeek)}
                    />
                    <label for="New this week">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_new_week")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_new_week"
                            )[0]["value"] || "lbl_new_week"
                          : "lbl_new_week"
                        : "lbl_new_week"}
                    </label>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* search box */}
          <div
            className="col-lg-2"
            style={{ marginBottom: "15px", marginTop: "7px" }}
          >
            <div className="">
              <FormGroup className="pt-0 ">
                <Col sm={12}>
                  <Input
                    type="text"
                    name="zipcode"
                    placeholder={
                      frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_enter_zipcode")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_enter_zipcode"
                            )[0]["value"] || "lbl_enter_zipcode"
                          : "lbl_enter_zipcode"
                        : "lbl_enter_zipcode"
                    }
                    className="set-bg-input"
                    autocomplete="off"
                    onClick={handleZipCode}
                    value={""}
                    style={{ color: "transparent" }}
                    // onChange={onFilterChange}
                  />
                </Col>
                {openZip && (
                  <div className="zipcode-style">
                    <CheckboxTree
                      // expandMode="Single"
                      // nodes={filterText.length !== 0 ? nodesFiltered : nodes}
                      // checked={checkedTree}
                      // expanded={expandedTree}
                      // expandOnClick={true}
                      // onClick={(clickedTree) => setClickedTree(clickedTree)}
                      // onCheck={(checkedTree) => {
                      //   setCheckedTree(checkedTree);
                      //   setFilterText(checkedTree.toString());
                      // }}
                      // onExpand={(expandedTree) => setExpandedTree(expandedTree)}
                      // icons={icons}
                      // toggle={true}
                      nodes={nodes}
                      checked={checkedTree}
                      expanded={expandedTree}
                      expandOnClick={true}
                      onClick={(clickedTree) => setClickedTree(clickedTree)}
                      onCheck={(checkedTree) => {
                        setCheckedTree(checkedTree);
                        setFilterText(checkedTree.toString());
                      }}
                      onExpand={(expandedTree) => setExpandedTree(expandedTree)}
                      icons={icons}
                      // nativeCheckboxes={true}
                    />
                  </div>
                )}
              </FormGroup>
              <FormGroup row className="set-bg-feild">
                <Col sm={12} style={{ position: "relative" }}>
                  <Input
                    type="text"
                    placeholder={
                      frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_search_street_name"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_search_street_name"
                            )[0]["value"] || "lbl_search_street_name"
                          : "lbl_search_street_name"
                        : "lbl_search_street_name"
                    }
                    className="set-bg-input"
                    style={{ paddingLeft: 40 }}
                    value={search}
                    name="search"
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyPress={handleEnter}
                  />
                  <i
                    className="fa fa-search search-icon-style"
                    // style={{
                    //   position: "absolute",
                    //   top: 13,
                    //   left: 30,
                    //   color: "#8b9194",
                    //   fontSize: 13,
                    // }}
                  />
                </Col>
              </FormGroup>
              <FormGroup row className="set-bg-feild">
                <Col sm={12}>
                  <select
                    name="select"
                    id="exampleSelect"
                    className="set-bg-input"
                    style={{ width: "100%" }}
                    value={propertyType}
                    onChange={(e) => setPropertyType(e.target.value)}
                  >
                    <option selected value={""}>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_select_property_type"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_select_property_type"
                            )[0]["value"] || "lbl_select_property_type"
                          : "lbl_select_property_type"
                        : "lbl_select_property_type"}
                    </option>
                    <option value={"detachedHouse"}>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_detached_house"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_detached_house"
                            )[0]["value"] || "lbl_detached_house"
                          : "lbl_detached_house"
                        : "lbl_detached_house"}
                    </option>
                    <option value={"duplex"}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_duplex")
                            .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0][
                              "value"
                            ] || "lbl_duplex"
                          : "lbl_duplex"
                        : "lbl_duplex"}
                    </option>
                    <option value={"tripleAptHouse"}>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_triple_apt_house"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_triple_apt_house"
                            )[0]["value"] || "lbl_triple_apt_house"
                          : "lbl_triple_apt_house"
                        : "lbl_triple_apt_house"}
                    </option>
                    <option value={"aptBulding"}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_apt_building"
                            )[0]["value"] || "lbl_apt_building"
                          : "lbl_apt_building"
                        : "lbl_apt_building"}
                    </option>
                    <option value={"townhouseTwin"}>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_townhouse_twin"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_townhouse_twin"
                            )[0]["value"] || "lbl_townhouse_twin"
                          : "lbl_townhouse_twin"
                        : "lbl_townhouse_twin"}
                    </option>
                    <option value={"garage"}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_garage")
                            .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0][
                              "value"
                            ] || "lbl_garage"
                          : "lbl_garage"
                        : "lbl_garage"}
                    </option>
                    <option value={"summerHouse"}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_summer_house"
                            )[0]["value"] || "lbl_summer_house"
                          : "lbl_summer_house"
                        : "lbl_summer_house"}
                    </option>
                    <option value={"cotenant"}>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_co_tenant"
                            )[0]["value"] || "lbl_co_tenant"
                          : "lbl_co_tenant"
                        : "lbl_co_tenant"}
                    </option>
                    <option value={"hotelGesthouse"}>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_hotel_guest_house"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_hotel_guest_house"
                            )[0]["value"] || "lbl_hotel_guest_house"
                          : "lbl_hotel_guest_house"
                        : "lbl_hotel_guest_house"}
                    </option>
                  </select>
                </Col>
              </FormGroup>
            </div>
          </div>
          {/* property  */}
          <div className="col-lg-3" style={{ marginBottom: "25px" }}>
            <div className="property ">
              <h2>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_room")
                      .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_property_room")[0][
                        "value"
                      ] || "lbl_property_room"
                    : "lbl_property_room"
                  : "lbl_property_room"}
              </h2>
              <h6>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_bedroom").length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_bedroom")[0][
                        "value"
                      ] || "lbl_bedroom"
                    : "lbl_bedroom"
                  : "lbl_bedroom"}
              </h6>
              <div className="link-btn-sets">
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "Storage") {
                      setRoom("Storage");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <span
                    className={
                      room === "Storage" ? "set-bg-btn-no66" : "set-bg-btn-no55"
                    }
                  >
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_storage")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0][
                            "value"
                          ] || "lbl_storage"
                        : "lbl_storage"
                      : "lbl_storage"}
                  </span>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "Single Room") {
                      setRoom("Single Room");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <span
                    className={
                      room === "Single Room"
                        ? "set-bg-btn-no66"
                        : "set-bg-btn-no55"
                    }
                  >
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_single_room")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_single_room"
                          )[0]["value"] || "lbl_single_room"
                        : "lbl_single_room"
                      : "lbl_single_room"}
                  </span>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "Studio") {
                      setRoom("Studio");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <span
                    className={
                      room === "Studio" ? "set-bg-btn-no66" : "set-bg-btn-no55"
                    }
                  >
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_studio").length >
                        0
                        ? frontLabelsName.filter((e) => e.key == "lbl_studio")[0][
                            "value"
                          ] || "lbl_studio"
                        : "lbl_studio"
                      : "lbl_studio"}
                  </span>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "2") {
                      setRoom("2");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <div
                    className={
                      room === "2" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    2
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "3") {
                      setRoom("3");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  {" "}
                  <div
                    className={
                      room === "3" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    3
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "4") {
                      setRoom("4");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  {" "}
                  <div
                    className={
                      room === "4" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    4
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "5") {
                      setRoom("5");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  {" "}
                  <div
                    className={
                      room === "5" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    5
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "6") {
                      setRoom("6");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  {" "}
                  <div
                    className={
                      room === "6" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    6
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "7") {
                      setRoom("7");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <div
                    className={
                      room === "7" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    7
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "8") {
                      setRoom("8");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <div
                    className={
                      room === "8" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    8
                  </div>
                </div>
                <div
                  className="set-bg-btn-no"
                  onClick={() => {
                    if (room !== "9") {
                      setRoom("9");
                    } else {
                      setRoom("");
                    }
                  }}
                >
                  <div
                    className={
                      room === "9" ? "set-bg-btn-no6" : "set-bg-btn-no5"
                    }
                  >
                    9+
                  </div>
                </div>
              </div>
            </div>
            <div className="advnace-button pt-3">
              <button
                className="advace-btn"
                onClose={handleClose}
                onClick={() => setOpen1((open) => !open1)}
                type="button"
                style={{}}
              >
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_advanced").length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_advanced")[0][
                        "value"
                      ] || "lbl_advanced"
                    : "lbl_advanced"
                  : "lbl_advanced"}
              </button>
              {open1 && (
                <div className="advanced-btn-content">
                  <div>
                    <FormGroup row className="set-bg-feild">
                      <Col sm={12}>
                        <select
                          name="select"
                          id="inhabitants"
                          className="set-bg-input"
                          style={{ width: "100%" }}
                          value={inhabitants}
                          onChange={(e) => {
                            setInhabitants(e.target.value);
                          }}
                        >
                          <option value={""}>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) =>
                                    e.key == "lbl_allowed_number_of_inhabitants"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) =>
                                      e.key ==
                                      "lbl_allowed_number_of_inhabitants"
                                  )[0]["value"] ||
                                  "lbl_allowed_number_of_inhabitants"
                                : "lbl_allowed_number_of_inhabitants"
                              : "lbl_allowed_number_of_inhabitants"}
                          </option>
                          <option value={"agreement"}>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_agreement"
                                  )[0]["value"] || "lbl_agreement"
                                : "lbl_agreement"
                              : "lbl_agreement"}
                          </option>
                          <option value={"1"}>1</option>
                          <option value={"2"}>2</option>
                          <option value={"3"}>3</option>
                          <option value={"4"}>4</option>
                          <option value={"5"}>5</option>
                          <option value={"6"}>6</option>
                          <option value={"7"}>7</option>
                          <option value={"8"}>8</option>
                          <option value={"9"}>9</option>
                          <option value={"10"}>10</option>
                        </select>
                      </Col>
                    </FormGroup>
                    <FormGroup row className="set-bg-feild ">
                      <Col sm={12}>
                        <select
                          name="select"
                          id="gender"
                          className="set-bg-input"
                          style={{ width: "100%" }}
                          value={gender}
                          onChange={(e) => {
                            setGender(e.target.value);
                          }}
                        >
                          <option value={""}>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_select_gender"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_select_gender"
                                  )[0]["value"] || "lbl_select_gender"
                                : "lbl_select_gender"
                              : "lbl_select_gender"}
                          </option>
                          <option value={0}>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_all_gender"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_all_gender"
                                  )[0]["value"] || "lbl_all_gender"
                                : "lbl_all_gender"
                              : "lbl_all_gender"}
                          </option>
                          <option value={1}>
                            {" "}
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_only_male"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_only_male"
                                  )[0]["value"] || "lbl_only_male"
                                : "lbl_only_male"
                              : "lbl_only_male"}
                          </option>
                          <option value={2}>
                            {" "}
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_only_female"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_only_female"
                                  )[0]["value"] || "lbl_only_female"
                                : "lbl_only_female"
                              : "lbl_only_female"}
                          </option>
                          <option value={3}>
                            {" "}
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_other")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_other"
                                  )[0]["value"] || "lbl_other"
                                : "lbl_other"
                              : "lbl_other"}
                          </option>
                          <option value={4}>
                            {" "}
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_couples")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_couples"
                                  )[0]["value"] || "lbl_couples"
                                : "lbl_couples"
                              : "lbl_couples"}
                          </option>
                        </select>
                      </Col>
                    </FormGroup>
                    <div className="set-btn-no">
                      <h6 className="pt-0">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_smoking")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_smoking"
                              )[0]["value"] || "lbl_smoking"
                            : "lbl_smoking"
                          : "lbl_smoking"}
                      </h6>
                      <div className="d-flex justify-content-between field-group-div">
                        <div className="field-group10 d-flex align-items-center">
                          <label htmlFor="smoking1">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_yes"
                                  )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"}
                          </label>
                          <input
                            id="smoking1"
                            type="checkbox"
                            value={smoking}
                            onChange={() => {
                              if (smoking !== "1") {
                                setSmoking("1");
                              } else {
                                setSmoking("");
                              }
                            }}
                            checked={smoking === "1"}
                            className="ms-1"
                          />
                        </div>
                        <div className="field-group10 d-flex align-items-center">
                          <label htmlFor="smoking2">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no"
                                  )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"}
                          </label>
                          <input
                            id="smoking2"
                            type="checkbox"
                            value={smoking}
                            onChange={() => {
                              if (smoking !== "2") {
                                setSmoking("2");
                              } else {
                                setSmoking("");
                              }
                            }}
                            checked={smoking === "2"}
                            className="ms-1"
                          />
                        </div>
                        <div className="field-group10 d-flex align-items-center">
                          <label htmlFor="smoking3">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_agreement"
                                  )[0]["value"] || "lbl_agreement"
                                : "lbl_agreement"
                              : "lbl_agreement"}
                          </label>
                          <input
                            id="smoking3"
                            type="checkbox"
                            value={smoking}
                            onChange={() => {
                              if (smoking !== "3") {
                                setSmoking("3");
                              } else {
                                setSmoking("");
                              }
                            }}
                            checked={smoking === "3"}
                            className="ms-1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="set-btn-no pt-2">
                      <h6>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_pets")
                              .length > 0
                            ? frontLabelsName.filter((e) => e.key == "lbl_pets")[0][
                                "value"
                              ] || "lbl_pets"
                            : "lbl_pets"
                          : "lbl_pets"}
                      </h6>
                      <div className="d-flex justify-content-between field-group-div">
                        <div className="field-group10 d-flex align-items-center">
                          <label htmlFor="pets1">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_yes")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_yes"
                                  )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"}
                          </label>
                          <input
                            id="pets1"
                            type="checkbox"
                            value={pets}
                            onChange={() => {
                              if (pets !== "1") {
                                setPets("1");
                              } else {
                                setPets("");
                              }
                            }}
                            checked={pets === "1"}
                            className="ms-1"
                          />
                        </div>
                        <div className="field-group10 d-flex align-items-center">
                          <label htmlFor="pets2">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no"
                                  )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"}
                          </label>
                          <input
                            id="pets2"
                            type="checkbox"
                            value={pets}
                            onChange={() => {
                              if (pets !== "2") {
                                setPets("2");
                              } else {
                                setPets("");
                              }
                            }}
                            checked={pets === "2"}
                            className="ms-1"
                          />
                        </div>
                        <div className="field-group10 d-flex align-items-center">
                          <label htmlFor="pets3">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_agreement"
                                  )[0]["value"] || "lbl_agreement"
                                : "lbl_agreement"
                              : "lbl_agreement"}
                          </label>
                          <input
                            id="pets3"
                            type="checkbox"
                            value={pets}
                            onChange={() => {
                              if (pets !== "3") {
                                setPets("3");
                              } else {
                                setPets("");
                              }
                            }}
                            checked={pets === "3"}
                            className="ms-1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <CheckboxTree
                    nodes={propertyFieldNodes}
                    checked={checkedPropertyFieldTree}
                    expanded={expandedPropertyFieldTree}
                    expandOnClick={true}
                    onClick={(checkedPropertyFieldTree) =>
                      setClickedPropertyFieldTree(checkedPropertyFieldTree)
                    }
                    onCheck={(checkedPropertyFieldTree) => {
                      setCheckedPropertyFieldTree(checkedPropertyFieldTree);
                      setFilterPropertyFieldText(
                        checkedPropertyFieldTree.toString()
                      );
                    }}
                    onExpand={(expandedPropertyFieldTree) =>
                      setExpandedPropertyFieldTree(expandedPropertyFieldTree)
                    }
                    icons={icons}
                    // nativeCheckboxes={true}
                  />
                  {/* {included1.length > 0 &&
                    included1.map((inc, i) => {
                      return (
                        <div style={{ marginLeft: 5 }} className="field-group2">
                          <input
                            id={inc._id}
                            type="checkbox"
                            name={inc?.name}
                            value={inc._id}
                            // onChange={handleCheckbox}
                            checked={other?.includes(inc._id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setOther([...other, e.target.value]);
                              } else {
                                const filterVal = other.filter(
                                  (val, i) => val !== e.target.value
                                );
                                setOther(filterVal);
                              }
                            }}
                          />
                          <label
                            htmlFor={inc._id}
                            className="advanced-content-label"
                          >
                            {inc?.name}
                          </label>
                        </div>
                      );
                    })} */}
                  {/* <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="2"
                      type="checkbox"
                      name="withElevator"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="2" className="advanced-content-label">
                      By elevator
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="3"
                      type="checkbox"
                      name="Garage"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="3" className="advanced-content-label">
                      With garage
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="4"
                      type="checkbox"
                      name="privateEntrance"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="4" className="advanced-content-label">
                      With private entrance
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="5"
                      type="checkbox"
                      name="storage"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="5" className="advanced-content-label">
                      With storage
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="6"
                      type="checkbox"
                      name="bathroomBath"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="6" className="advanced-content-label">
                      With shower
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="7"
                      type="checkbox"
                      name="Pets"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="7" className="advanced-content-label">
                      Pets allowed
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="8"
                      type="checkbox"
                      name="withCharging"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="8" className="advanced-content-label">
                      With charging station for electric cars
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="9"
                      type="checkbox"
                      name="laundryFacilitiesInTheBasement"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="9" className="advanced-content-label">
                      With laundry facilities
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="10"
                      type="checkbox"
                      name="withWheelchair"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="10" className="advanced-content-label">
                      With wheelchair access
                    </label>
                  </div>
                  <div style={{ marginLeft: 5 }} className="field-group2">
                    <input
                      id="11"
                      type="checkbox"
                      name="withBalcony"
                      onChange={handleCheckbox}
                    />
                    <label htmlFor="11" className="advanced-content-label">
                      With balcony
                    </label>
                  </div> */}
                </div>
              )}
            </div>
          </div>
          {/* rental period */}
          <div className="col-lg-2" style={{ marginBottom: "25px" }}>
            <div className="rental">
              <h2>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_rental_period")
                      .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_rental_period")[0][
                        "value"
                      ] || "lbl_rental_period"
                    : "lbl_rental_period"
                  : "lbl_rental_period"}
              </h2>
              <div className="check-sets-available">
                <div className="field-group1 pb-3">
                  <label htmlFor="15">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_available_now")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_available_now"
                          )[0]["value"] || "lbl_available_now"
                        : "lbl_available_now"
                      : "lbl_available_now"}
                  </label>
                  <input
                    id="15"
                    type="checkbox"
                    value={rentalPeriod}
                    onChange={() => {
                      if (rentalPeriod !== "1") {
                        setRentalPeriod("1");
                      } else {
                        setRentalPeriod("");
                      }
                    }}
                    checked={rentalPeriod === "1"}
                  />
                </div>

                <div className="field-group1 pt-3 pb-3">
                  <label htmlFor="16">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_short_term_rental"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_short_term_rental"
                          )[0]["value"] || "lbl_short_term_rental"
                        : "lbl_short_term_rental"
                      : "lbl_short_term_rental"}
                  </label>
                  <input
                    id="16"
                    type="checkbox"
                    value={rentalPeriod}
                    onChange={() => {
                      if (rentalPeriod !== "2") {
                        setRentalPeriod("2");
                      } else {
                        setRentalPeriod("");
                      }
                    }}
                    checked={rentalPeriod === "2"}
                  />
                </div>
                <div
                  className="field-group1 pt-3 pb-3"
                  style={{ borderBottom: "none" }}
                >
                  <label htmlFor="17">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_long_term_rental"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_long_term_rental"
                          )[0]["value"] || "lbl_long_term_rental"
                        : "lbl_long_term_rental"
                      : "lbl_long_term_rental"}
                  </label>
                  <input
                    id="17"
                    type="checkbox"
                    value={rentalPeriod}
                    onChange={() => {
                      if (rentalPeriod !== "3") {
                        setRentalPeriod("3");
                      } else {
                        setRentalPeriod("");
                      }
                    }}
                    checked={rentalPeriod === "3"}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* property price */}
          <div className="col-lg-3" style={{ marginBottom: "15px" }}>
            <div className="Property_Price">
              <h2>
                {" "}
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_price")
                      .length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_property_price"
                      )[0]["value"] || "lbl_property_price"
                    : "lbl_property_price"
                  : "lbl_property_price"}
              </h2>
              <span className="set-val-price">
              kr {propPriceVal.min} - kr {propPriceVal.max}+
              </span>
              {/* <div> */}
              {/* <Slider
                  classes={{
                    thumb: classes.thumb1,
                    rail: classes.rail1,
                    track: classes.track1,
                  }}
                  step={10}
                  min={10}
                  max={100}
                  value={propPriceVal}
                  onChange={(ev, v) => setPropPriceVal(v)}
                  valueLabelDisplay="auto"
                  aria-labelledby="range-slider"
                  sx={{ color: "fff" }}
                /> */}

              <div className="py-4 ">
                <InputRange
                  step={5}
                  formatLabel={(value) => null}
                  draggableTrack={false}
                  allowSameValues={false}
                  maxValue={2000000}
                  minValue={100}
                  value={propPriceVal}
                  onChange={setPropPriceVal}
                  onChangeComplete={(args) => setPriceData(args)}
                />
              </div>
              {/* </div> */}
            </div>

            <div className="Property_Price">
              <h2>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_property_size")
                      .length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_property_size")[0][
                        "value"
                      ] || "lbl_property_size"
                    : "lbl_property_size"
                  : "lbl_property_size"}
              </h2>
              <span className="set-val-price">
                {propSizeVal.min} - {propSizeVal.max} m<sup>2</sup>
              </span>
              {/* <div>
                <Slider
                  classes={{
                    thumb: classes.thumb1,
                    rail: classes.rail1,
                    track: classes.track1,
                  }}
                  step={10}
                  min={0}
                  max={100000}
                  value={propSizeVal}
                  onChange={(ev, v) => setPropSizeVal(v)}
                  valueLabelDisplay="off"
                  aria-labelledby="range-slider"
                /> */}

              <div className="pt-4">
                <InputRange
                  step={5}
                  formatLabel={(value) => null}
                  draggableTrack={false}
                  allowSameValues={false}
                  maxValue={3600}
                  minValue={0}
                  value={propSizeVal}
                  onChange={setPropSizeVal}
                  onChangeComplete={(args) => setSizeData(args)}
                />
              </div>
              {/* </div> */}
            </div>
            <div className="d-flex set-reset-space align-items-center pt-4">
              <button className="reset-btn" onClick={onResetFilter}>
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_reset").length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_reset")[0][
                        "value"
                      ] || "lbl_reset"
                    : "lbl_reset"
                  : "lbl_reset"}
              </button>{" "}
              <div className="apply-btn">
                <button onClick={onApplyFilter}>
                  <BsCheck2
                    className="set-gap-app"
                    style={{ fontWeight: "bold" }}
                  />
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_apply").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_apply")[0][
                          "value"
                        ] || "lbl_apply"
                      : "lbl_apply"
                    : "lbl_apply"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

        {/* map */}
        {!filterLoading && (
          <div className="row">
            <div className="col-lg-12 pt-5 pb-4">
              {/* <iframe
              src="https://maps.google.com/maps?q=23.0522,72.5497&hl=es&z=14&amp;output=embed"
              // width="100%"
              // height="856px"
              className="google-map-style"
              frameborder="0"
              style={{ border: "0px" }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe> */}
              <div className="google-map-style ">
                <MapComponent
                  property={property}
                  propertyLoading={propertyLoading}
                  hidden={hidden}
                  unlike={unlike}
                  like={like}
                />
              </div>
            </div>
          </div>
        )}

        {filterLoading && <Loading />}
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {
  getPropertyList,
  unlikeProperty,
  likeProperty,
  hiddenProperty,
  dropdownPropertyField,
  runningSubscription,
})(MapView1);
